import { BottomNavigation, BottomNavigationAction, createStyles, SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Icons } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useMst } from '../../mobx-models/Root';
import { WORK_PACKAGE_NAV_TAB } from '../../utilities/constants';
import { getValueFromLocalStorage } from '../../utilities/utilityFunctions';
import WorkpackageNavTab from '../WorkpackageNavTab';
import ConfirmSavingDialog from './ConfirmSaving';
import TabBarConfig from './TabBarConfig.json';

const useStyles = makeStyles(() =>
  createStyles({
    hidden: {
      display: 'none',
    },
    root: {
      position: 'absolute',
      bottom: '0px',
      width: '100%',
      justifyContent: 'space-between',
      height: '75px',
      boxShadow: '0px 0px 16px 0px rgba(0, 0, 0, 1)',
    },
    label: {
      paddingTop: '4px',
    },
    navActionLabels: {
      paddingTop: 4,
    },
    navActionButtonDisabled: {
      color: 'rgba(255, 255, 255, 0.38)',
    },
    navActionButtonInActive: {
      color: 'rgba(255, 255, 255, 0.87)',
    },
  }),
);

const checkIfVisible = (pathname: string) => {
  return TabBarConfig.blacklistedPaths.indexOf(pathname) === -1;
};

const getActiveTabNumber = (pathname: string, tabValue: number) => {
  let result = -1;
  const isElectrical =
    JSON.parse(getValueFromLocalStorage('selectedDiscipline') || '{}')?.selectedDisciplineId === 1;
  if (!isElectrical) {
    TabBarConfig.items
      .filter(i => (tabValue ? i.key !== 'inspection-list' : i.key))
      .forEach((item: { path: string }, index: number) => {
        if (item.path.includes(pathname)) {
          result = index;
        }
      });
  } else {
    TabBarConfig.itemsForElectrical
      .filter(i => (tabValue ? i.key !== 'inspection-list' : i.key))
      .forEach((item: { path: string }, index: number) => {
        if (item.path.includes(pathname)) {
          result = index;
        }
      });
  }
  return result;
};

const checkInspectionList = () => {
  return location.pathname.indexOf('inspection-list') !== -1;
};

const checkWorkPackage = () => {
  return location.pathname.indexOf('work-packages') !== -1;
};

const svgIconForInspectionList = () => {
  return (
    <SvgIcon>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.91776 5.5706C3.33251 5.15585 3.89502 4.92285 4.48155 4.92285H11.5585C11.6758 4.92285 11.7883 4.96945 11.8712 5.0524L17.1789 10.3601C17.2619 10.443 17.3085 10.5555 17.3085 10.6728V21.2882C17.3085 21.8747 17.0755 22.4373 16.6607 22.852C16.246 23.2667 15.6835 23.4997 15.0969 23.4997H4.48155C3.89502 23.4997 3.33251 23.2667 2.91776 22.852C2.50302 22.4373 2.27002 21.8747 2.27002 21.2882V7.13439C2.27002 6.54785 2.50302 5.98534 2.91776 5.5706ZM4.48155 5.80747C4.12963 5.80747 3.79213 5.94727 3.54328 6.19611C3.29443 6.44496 3.15463 6.78247 3.15463 7.13439V21.2882C3.15463 21.6401 3.29443 21.9776 3.54328 22.2265C3.79213 22.4753 4.12963 22.6151 4.48155 22.6151H15.0969C15.4488 22.6151 15.7864 22.4753 16.0352 22.2265C16.284 21.9776 16.4238 21.6401 16.4238 21.2882V10.8561L11.3753 5.80747H4.48155Z"
          fill={
            checkInspectionList()
              ? '#2AAB3F'
              : checkWorkPackage()
              ? 'rgba(255, 255, 255, 0.38)'
              : 'rgba(255, 255, 255, 0.87)'
          }
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5585 4.92285C11.8028 4.92285 12.0008 5.12088 12.0008 5.36516V10.2305H16.8662C17.1105 10.2305 17.3085 10.4286 17.3085 10.6728C17.3085 10.9171 17.1105 11.1151 16.8662 11.1151H11.5585C11.3142 11.1151 11.1162 10.9171 11.1162 10.6728V5.36516C11.1162 5.12088 11.3142 4.92285 11.5585 4.92285Z"
          fill={
            checkInspectionList()
              ? '#2AAB3F'
              : checkWorkPackage()
              ? 'rgba(255, 255, 255, 0.38)'
              : 'rgba(255, 255, 255, 0.87)'
          }
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.80859 15.0961C5.80859 14.8518 6.00662 14.6538 6.2509 14.6538H13.3278C13.5721 14.6538 13.7701 14.8518 13.7701 15.0961C13.7701 15.3404 13.5721 15.5384 13.3278 15.5384H6.2509C6.00662 15.5384 5.80859 15.3404 5.80859 15.0961Z"
          fill={
            checkInspectionList()
              ? '#2AAB3F'
              : checkWorkPackage()
              ? 'rgba(255, 255, 255, 0.38)'
              : 'rgba(255, 255, 255, 0.87)'
          }
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.80859 18.6347C5.80859 18.3904 6.00662 18.1924 6.2509 18.1924H13.3278C13.5721 18.1924 13.7701 18.3904 13.7701 18.6347C13.7701 18.879 13.5721 19.077 13.3278 19.077H6.2509C6.00662 19.077 5.80859 18.879 5.80859 18.6347Z"
          fill={
            checkInspectionList()
              ? '#2AAB3F'
              : checkWorkPackage()
              ? 'rgba(255, 255, 255, 0.38)'
              : 'rgba(255, 255, 255, 0.87)'
          }
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.80859 11.5575C5.80859 11.3133 6.00662 11.1152 6.2509 11.1152H8.02013C8.26441 11.1152 8.46244 11.3133 8.46244 11.5575C8.46244 11.8018 8.26441 11.9998 8.02013 11.9998H6.2509C6.00662 11.9998 5.80859 11.8018 5.80859 11.5575Z"
          fill={
            checkInspectionList()
              ? '#2AAB3F'
              : checkWorkPackage()
              ? 'rgba(255, 255, 255, 0.38)'
              : 'rgba(255, 255, 255, 0.87)'
          }
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.90441 0.5C8.31787 0.5 7.75536 0.733 7.34061 1.14774C6.92587 1.56249 6.69287 2.125 6.69287 2.71154V3.01821H7.57749V2.71154C7.57749 2.35961 7.71729 2.02211 7.96613 1.77326C8.21498 1.52441 8.55248 1.38461 8.90441 1.38461H15.7981L20.8467 6.4332V16.8654C20.8467 17.2173 20.7069 17.5548 20.458 17.8036C20.2092 18.0525 19.8717 18.1923 19.5198 18.1923H19.1991V19.0769H19.5198C20.1063 19.0769 20.6688 18.8439 21.0836 18.4292C21.4983 18.0144 21.7313 17.4519 21.7313 16.8654V6.24999C21.7313 6.13268 21.6847 6.02018 21.6018 5.93723L16.2941 0.629549C16.2111 0.5466 16.0986 0.5 15.9813 0.5H8.90441Z"
          fill={
            checkInspectionList()
              ? '#2AAB3F'
              : checkWorkPackage()
              ? 'rgba(255, 255, 255, 0.38)'
              : 'rgba(255, 255, 255, 0.87)'
          }
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.9814 0.5C16.2256 0.5 16.4237 0.698028 16.4237 0.942307V5.80768H21.2891C21.5333 5.80768 21.7314 6.00571 21.7314 6.24999C21.7314 6.49427 21.5333 6.6923 21.2891 6.6923H15.9814C15.7371 6.6923 15.5391 6.49427 15.5391 6.24999V0.942307C15.5391 0.698028 15.7371 0.5 15.9814 0.5Z"
          fill={
            checkInspectionList()
              ? '#2AAB3F'
              : checkWorkPackage()
              ? 'rgba(255, 255, 255, 0.38)'
              : 'rgba(255, 255, 255, 0.87)'
          }
        />
      </svg>
    </SvgIcon>
  );
};

const TabBar: React.FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const { SaveChecklist, saveInspection, SavePMChecklist, WorkPackageTabs } = useMst();
  const isElectrical =
    JSON.parse(getValueFromLocalStorage('selectedDiscipline') || '{}')?.selectedDisciplineId === 1;
  const [tabValue, setTabValue] = useState(WorkPackageTabs.tab);
  const [visible, setVisible] = useState(checkIfVisible(location.pathname));
  const [value, setValue] = useState(getActiveTabNumber(location.pathname, tabValue));
  const [futurePath, setFuturePath] = useState(-1);
  const [saveChecklist, setSaveChecklist] = useState(false);
  const [savePMChecklist, setSavePMChecklist] = useState(false);

  useEffect(() => {
    if (WorkPackageTabs.tab || WorkPackageTabs.tab === 0) {
      setTabValue(Number(WorkPackageTabs.tab));
    }
  }, [WorkPackageTabs.tab]);

  useEffect(() => {
    const visibleOne = checkIfVisible(location.pathname);
    const activeTabNumber = getActiveTabNumber(location.pathname, tabValue);
    setVisible(visibleOne);
    setValue(activeTabNumber);
  }, [location.pathname]);

  const changeTabOption = (e: React.MouseEvent<HTMLButtonElement>, val: number) => {
    if (
      val === WORK_PACKAGE_NAV_TAB.WORKPACKAGE.VALUE ||
      val === WORK_PACKAGE_NAV_TAB.ADHOC.VALUE
    ) {
      setTabValue(val);
      WorkPackageTabs.setTab(val);
    }
    e.stopPropagation();
  };

  const getIconFromName = (name: string) => {
    switch (name) {
      case 'FolderFeather':
        return <WorkpackageNavTab changeTab={changeTabOption} tabValue={tabValue} />;
      case 'more-file':
        return svgIconForInspectionList();
      case 'FileTextFeather':
        return <Icons.FileTextFeather color="white" />;
      case 'SettingsFeather':
        return <Icons.SettingsFeather color="white" />;
      case 'CheckCircleFeather':
        return <Icons.CheckCircleIcon color="white" />;
      case 'ArrowRightFeather':
        return <Icons.ArrowRightFeather color="white" />;
      default:
        return <Icons.HelpCircleFeather color="white" />;
    }
  };

  const checkTabDisabled = (tab: string) => {
    if (tab === '/work-packages') {
      return false;
    } else if (tab === '/inspection-list') {
      if (checkWorkPackage()) {
        return true;
      }
      return false;
    } else {
      if (checkWorkPackage() || checkInspectionList()) {
        return true;
      }
      return false;
    }
  };

  const getTabNameByValue = (val: number) => {
    if (val === WORK_PACKAGE_NAV_TAB.WORKPACKAGE.VALUE)
      return isElectrical ? 'Routes' : WORK_PACKAGE_NAV_TAB.WORKPACKAGE.LABEL;
    if (val === WORK_PACKAGE_NAV_TAB.ADHOC.VALUE) return WORK_PACKAGE_NAV_TAB.ADHOC.LABEL;
  };

  return (
    <>
      {!isElectrical && (
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => {
            if (
              SaveChecklist.isChangedTrue ||
              (saveInspection.isChanged && !saveInspection.isSaved)
            )
              setFuturePath(newValue);
            else setValue(newValue);
          }}
          showLabels
          className={visible ? classes.root : classes.hidden}
        >
          {TabBarConfig.items
            .filter(i => (tabValue ? i.key !== 'inspection-list' : i.key))
            .map(item => {
              return (
                <BottomNavigationAction
                  key={item.key}
                  label={
                    <div className={classes.navActionLabels}>
                      {item.label === 'Work Packages' ? getTabNameByValue(tabValue) : item.label}
                    </div>
                  }
                  icon={getIconFromName(item.iconName)}
                  data-cy={`tabbar-${item.key}`}
                  disabled={checkTabDisabled(item.path)}
                  className={
                    checkTabDisabled(item.path)
                      ? classes.navActionButtonDisabled
                      : location.pathname !== item.path
                      ? classes.navActionButtonInActive
                      : ''
                  }
                  onClick={() => {
                    if (
                      SaveChecklist.isChangedTrue ||
                      (saveInspection.isChanged && !saveInspection.isSaved)
                    ) {
                      setSaveChecklist(true);
                    } else {
                      history.push(item.path);
                    }
                  }}
                />
              );
            })}
        </BottomNavigation>
      )}
      {isElectrical && (
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => {
            if (
              SavePMChecklist.isChangedTrue ||
              (saveInspection.isChanged && !saveInspection.isSaved)
            )
              setFuturePath(newValue);
            else setValue(newValue);
          }}
          showLabels
          className={visible ? classes.root : classes.hidden}
        >
          {TabBarConfig.itemsForElectrical
            .filter(i => (tabValue ? i.key !== 'inspection-list' : i.key))
            .map(item => {
              return (
                <BottomNavigationAction
                  key={item.key}
                  label={
                    <div className={classes.navActionLabels}>
                      {' '}
                      {item.label === 'Routes' ? getTabNameByValue(tabValue) : item.label}
                    </div>
                  }
                  icon={getIconFromName(item.iconName)}
                  data-cy={`tabbar-${item.key}`}
                  disabled={checkTabDisabled(item.path)}
                  className={
                    checkTabDisabled(item.path)
                      ? classes.navActionButtonDisabled
                      : location.pathname !== item.path
                      ? classes.navActionButtonInActive
                      : ''
                  }
                  onClick={() => {
                    if (
                      SavePMChecklist.isChangedTrue ||
                      (saveInspection.isChanged && !saveInspection.isSaved)
                    ) {
                      setSavePMChecklist(true);
                    } else {
                      history.push(item.path);
                    }
                  }}
                />
              );
            })}
        </BottomNavigation>
      )}

      {isElectrical && savePMChecklist && (
        <ConfirmSavingDialog
          open={savePMChecklist}
          futurePath={futurePath}
          onClose={() => setSavePMChecklist(false)}
        />
      )}
      {!isElectrical && saveChecklist && (
        <ConfirmSavingDialog
          open={saveChecklist}
          futurePath={futurePath}
          onClose={() => setSaveChecklist(false)}
        />
      )}
    </>
  );
};

export default observer(TabBar);
